import SchoolIcon from "@mui/icons-material/School";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import classNames from "classnames";
import styles from "./style.module.scss";

export interface SchoolRef {
  id: number | string;
  name: string;
}

interface SchoolChipsProps {
  schools: SchoolRef[];
  onSelect?: (id: number | string) => void;
  /** "alert" is the red treatment used for schools with nobody assigning. */
  tone?: "default" | "alert";
  className?: string;
}

/** Inline list of school chips revealed under a band or a headline figure. */
function SchoolChips({
  schools,
  onSelect,
  tone = "default",
  className,
}: SchoolChipsProps) {
  if (!schools.length) return null;

  return (
    <div className={classNames(styles.chips, className)}>
      {schools.map((school) => (
        <button
          key={school.id}
          type="button"
          onClick={() => onSelect?.(school.id)}
          className={classNames(
            styles.chip,
            tone === "alert" && styles.chipAlert
          )}
        >
          {tone === "alert" ? (
            <WarningAmberIcon className={styles.chipIcon} />
          ) : (
            <SchoolIcon className={styles.chipIcon} />
          )}
          <span className={styles.chipName}>{school.name}</span>
        </button>
      ))}
    </div>
  );
}

export default SchoolChips;
